import { ColumnMapping } from 'api'
import { Result, Decimal } from 'utils'
import { parseCell } from './parseCell'
import { SpreadsheetParseError } from './utils'

export const createParseNumber = (_parseCell: typeof parseCell = parseCell) => (
  row: any,
  rowNum: number,
  columnMapping: ColumnMapping,
  fieldName: string,
  mandatory: boolean = false
): Result<number> =>
  _parseCell(row, rowNum, columnMapping, fieldName, mandatory).map(cellValue => {
    if (
      (typeof cellValue === 'string' && cellValue.replace(/[£€$%, ]/g, '').length > 13) ||
      (typeof cellValue === 'number' && cellValue > 9999999999999)
    ) {
      throw new SpreadsheetParseError(`"${cellValue}" is too long. Max supported length [13]`, rowNum, fieldName)
    }
    try {
      return Decimal.parse(typeof cellValue === 'string' ? cellValue.replace(/[£€$%, ]/g, '') : cellValue)
    } catch (err) {
      throw new SpreadsheetParseError(`"${cellValue}" is not a valid number`, rowNum, fieldName)
    }
  })

export const parseNumber = createParseNumber()
